export default __webpack_public_path__ + "static/media/blankslate-info-icon.32e7a5d7.svg";